module.exports = __webpack_public_path__ + "img/undraw_loading_re_5axr.bcd24bd3.svg";